let scrollPos = 0,
	headerHeight = document.querySelector('.jsSiteHeader').clientHeight,
	scrollTimeout,
	debounceTimeout;

let urgentMessage = document.querySelector('.jsUrgentMessage');
let urgentMessageHeight = urgentMessage ? urgentMessage.clientHeight : 0;
// adding scroll event
// document.defaultView.addEventListener('scroll', () => {
// 	handleScroll();
// });
document.defaultView.addEventListener('scroll', () => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
        handleScroll();
    }, 10);
});

function goingUp() {
	document.documentElement.classList.add('going-up');
	document.documentElement.classList.remove('going-down');
}
function goingDown() {
	document.documentElement.classList.add('going-down');
	document.documentElement.classList.remove('going-up');
}

function handleScroll() {
	// Note if scrolling starts
	document.documentElement.classList.add('is-scrolling');

	// Clear any existing timeout to ensure we don't remove the class prematurely
	clearTimeout(scrollTimeout);

	// Set a timeout to remove the 'is-scrolling' class after scrolling has stopped
	scrollTimeout = setTimeout(() => {
		document.documentElement.classList.remove('is-scrolling');
	}, 100);


	// If we're in iOS's "let's bounce the document to show we're at the top, and let's make it count as a scroll position" state, just stay in the "Going up so show everything" mode.
	if ( scrollPos > -headerHeight - urgentMessageHeight)
	{
		goingUp();
		document.documentElement.classList.add('at-top');
	}
	// detects new state and compares it with the new one
	else
	{
		document.documentElement.classList.remove('at-top');
		if ( (document.documentElement.getBoundingClientRect()).top > scrollPos )
		{
			goingUp();
		}
		else
		{
			goingDown();
		}
	}
	// saves the new position for iteration.
	scrollPos = (document.documentElement.getBoundingClientRect()).top;
}

// If any "clickables" in the header receive focus, ensure the header is visible

// Get all clickable elements in the header
const headerLinks = document.querySelectorAll('.jsSiteHeader a, .jsSiteHeader button, .jsSiteHeader input');

// Add event listener for focus
headerLinks.forEach((link) => {
	link.addEventListener('focus', () => {
		goingUp();
	});
});

handleScroll();